var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudwordsGlossary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1506_7030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2057 38.0381C18.0894 38.0381 17.973 38.0128 17.8653 37.9613L1.24031 30.0447C0.964813 29.9133 0.789062 29.6354 0.789062 29.3298V4.78814C0.789062 4.5166 0.928396 4.26406 1.15798 4.11839C1.38677 3.97351 1.67573 3.95689 1.92115 4.07326L18.2057 11.8276L34.4903 4.07247C34.7357 3.95689 35.0231 3.97272 35.2527 4.11839C35.4831 4.26406 35.6224 4.5166 35.6224 4.78814V29.3298C35.6224 29.6354 35.4466 29.9133 35.1711 30.0447L18.5461 37.9613C18.4385 38.0128 18.3221 38.0381 18.2057 38.0381ZM2.3724 28.8295L18.2057 36.3693L34.0391 28.8295V6.04214L18.5461 13.4197C18.3316 13.5218 18.0806 13.5218 17.8661 13.4197L2.3724 6.04214V28.8295Z",
    fill: "#2A4274",
    stroke: "#2A4274",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2057 9.65999L4.40455 3.08836C4.00951 2.89995 3.84247 2.42732 4.0301 2.03307C4.21851 1.63803 4.69035 1.47257 5.08539 1.65782L18.2057 7.90645L31.326 1.65782C31.7218 1.47257 32.1928 1.63803 32.3813 2.03307C32.5689 2.42732 32.4018 2.89995 32.0068 3.08836L18.2057 9.65999Z",
    fill: "#2A4274",
    stroke: "#2A4274",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9974 12.7031H17.4141V37.2448H18.9974V12.7031Z",
    fill: "#2A4274",
    stroke: "#2A4274",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_7030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudwordsGlossary);
export default __webpack_public_path__ + "static/media/cloudwords-glossary.f9f026d7a923e7b6264bc44ea10648e0.svg";
export { ForwardRef as ReactComponent };